import { SelectField } from "@dash/form";

export type ShopifyCancelReason = "CUSTOMER" | "DECLINED" | "FRAUD" | "INVENTORY" | "STAFF" | "OTHER";

const reasonRows: { value: ShopifyCancelReason; label: string }[] = [
  { value: "CUSTOMER", label: "Klient" },
  { value: "DECLINED", label: "Odrzucone" },
  { value: "FRAUD", label: "Oszustwo" },
  { value: "INVENTORY", label: "Brak na stanie" },
  { value: "STAFF", label: "Personel" },
  { value: "OTHER", label: "Inne" },
];

type Props = {
  value: ShopifyCancelReason;
  onChange: (value: ShopifyCancelReason) => void;
  isDisabled?: boolean;
};

export const CancelShopifyReasonField = ({ value, onChange, isDisabled }: Props) => {
  const selected = reasonRows.find((r) => r.value === value);
  const labelForDisplay = selected?.label ?? reasonRows[0]?.label ?? "";

  return (
    <SelectField
      label="Powód (Shopify)"
      value={labelForDisplay}
      onChange={(label) => {
        const row = reasonRows.find((r) => r.label === label);
        if (row) onChange(row.value);
      }}
      options={reasonRows.map((r) => r.label)}
      isDisabled={isDisabled}
    />
  );
};
